import { Grid2 as Grid, Typography } from "@mui/material";
import React from "react";
import useDebugInformation from "../../hooks/useDebugInformation";
import StepNumberIcon from "./StepNumberIcon";

const name = "NumberedHeader";

type NumberedHeaderProps = {
    number: string
    description: string
    variant: "green" | "orange" | "red"
}

const NumberedHeader: React.FC<NumberedHeaderProps> = ({ number, description, variant }) => {
    const debugName = `${name}`;

    useDebugInformation(debugName, { number, description, variant });
    return (
        (<Grid
            style={{ paddingTop: "0px", display: "inline-flex", margin: "0 auto", justifyContent: "center", columnGap: 2 }}
            size={{
                xs: 12,
                sm: 12
            }}>
            <StepNumberIcon number={number} variant={variant} /><Typography variant="body1" align="center">{description}</Typography>
        </Grid>)
    );
};

NumberedHeader.displayName = name;


export default React.memo(NumberedHeader);
